import { useParams, useSearchParams } from "react-router-dom";
import TranslationWrapper from "./translationWrapper";
import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import NameTableTranslatable from "./nameTableTranslateable";

import { GraphQLPagination } from "../common";
import { getQueryVariables } from "../../utils";
import CategoryTranslationForm from "./categoryTranslationForm";

const GET_CATEGORIES = gql`
query MyQuery ($first: Int, $after: String, $last: Int, $before: String) {
    categories(first: $first, after: $after, last: $last, before: $before) {
    edges {
      cursor
      node {
        dbId
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}`

function CategoryTranslation() {
    const { languageCode } = useParams<{ languageCode: string }>();
    const [categoryId, setCategoryId] = useState<number | null>(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    const { data, loading, error } = useQuery(GET_CATEGORIES, {
        variables: getQueryVariables(searchParams),
        notifyOnNetworkStatusChange: true,
    });

    const handleOpenForm = (id: number) => {
        setIsFormOpen(true);
        setCategoryId(id);
    };


    const handleCloseForm = () => setIsFormOpen(false);

    useEffect(() => {
        if (!searchParams.get("first") && !searchParams.get("last")) {
            setSearchParams({ first: "20" });
        }
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    const category = data?.categories?.edges || [];

    return (
        <TranslationWrapper>
            <>
                <NameTableTranslatable data={category} onOpenForm={handleOpenForm} />

                <GraphQLPagination
                    edges={data?.categories?.edges || []}
                    pageInfo={data?.categories?.pageInfo || {}}
                />

                {isFormOpen && (
                    <CategoryTranslationForm
                        id={categoryId}
                        isOpen={isFormOpen}
                        onClose={handleCloseForm}
                    />
                )}

            </>
        </TranslationWrapper>
    );
}

export default CategoryTranslation;